import { Box, Typography, Container } from '@mui/material';
import { useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { blockedMessages } from '@client/components';

export const BlockedPage = () => {
  const [searchParams] = useSearchParams();
  const { t } = useTranslation();

  const type = searchParams.get('type');
  let message = blockedMessages[type as keyof typeof blockedMessages];

  if (!message) message = blockedMessages.uk_restriction;

  return (
    <Box
      display="flex"
      height="100vh"
      justifyContent="center"
      alignItems="center"
      textAlign="center"
      bgcolor="background.default"
      color="text.primary"
      px={2}
    >
      <Container maxWidth="sm">
        <Typography variant="h4" gutterBottom>
          {t(message.titleKey)}
        </Typography>
        <Typography variant="body1">{t(message.bodyKey)}</Typography>
        <Typography variant="body2" mt={4} color="text.secondary">
          {t(message.footerKey)}
        </Typography>
      </Container>
    </Box>
  );
};
